import { IconColorPicker } from '@tabler/icons-react';
import { memo, useSyncExternalStore } from 'react';
import { useVideoImportContext } from '../../../VideoImportContext';
import { ColorPicker } from '@/components/atoms/ColorPicker/ColorPicker';
import { brandKit } from '@/stores/brandKit';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';

const BrandingColorSelect = () => {
  const { setSelectedColor, selectedColor } = useVideoImportContext();

  const brandKitStore = useSyncExternalStore(brandKit.subscribe, brandKit.getSnapshot);
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isPlatformBrandKitEnabled = featureFlags[FeatureFlagKeys.Use_CL_Platform_Brandkit];

  return (
    <div className="relative size-full">
      <ColorPicker
        hex={selectedColor}
        defaultColors={brandKitStore.colors}
        defaultColorsLabel="Brand Colors"
        pickerClassNames={
          isPlatformBrandKitEnabled
            ? 'left-full top-0 ml-2 rounded-xl border-none'
            : 'right-4 top-[-16px] rounded-xl border-none'
        }
        classNames="overflow-hidden rounded-lg !ring-2 ring-slate-200 !border-none"
        openClassNames="!ring-black"
        onChange={setSelectedColor}
      >
        <div className="relative flex size-full flex-col items-center justify-center overflow-hidden text-white">
          <IconColorPicker size={24} />
          <h2 className="mt-5 select-none text-sm font-medium leading-tight">Primary Color</h2>
        </div>
      </ColorPicker>
    </div>
  );
};

export default memo(BrandingColorSelect);
